var React = require('react');

function ContentInfoAlt (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-info-alt"),React.createElement("path",{"d":"M30.05,0A30.05,30.05,0,1,0,60.1,30.05,30.08,30.08,0,0,0,30.05,0Zm0,57.7A27.65,27.65,0,1,1,57.7,30.05,27.68,27.68,0,0,1,30.05,57.7Z","key":1}),React.createElement("path",{"d":"M29.76,22.64a4.13,4.13,0,0,0-3.05,1.27A4.2,4.2,0,0,0,25.45,27V42.9A4.32,4.32,0,0,0,32.82,46a4.12,4.12,0,0,0,1.27-3V27a4.2,4.2,0,0,0-1.26-3.06A4.14,4.14,0,0,0,29.76,22.64Z","key":2}),React.createElement("path",{"d":"M29.76,10.54a4.32,4.32,0,0,0-4.31,4.33,4.32,4.32,0,0,0,4.31,4.31,4.17,4.17,0,0,0,3.06-1.27,4.09,4.09,0,0,0,1.27-3,4.32,4.32,0,0,0-4.33-4.33Z","key":3})]);
}

ContentInfoAlt.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 60.1 60.1"};

module.exports = ContentInfoAlt;

ContentInfoAlt.default = ContentInfoAlt;
